"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Withdrawal = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsAccount_1 = require("../../model/hsAccount");
var service_1 = require("../../../library/base/service");
var Withdrawal = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Withdrawal, _super);
    function Withdrawal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '账户余额提现接口';
        _this.code = '105003';
        _this.desc = '账户余额提现接口';
        _this.requestParams = new hsAccount_1.WithdrawalRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Withdrawal;
}(service_1.BaseService));
exports.Withdrawal = Withdrawal;
//# sourceMappingURL=withdrawal.js.map